import { Lightning, Router } from '@lightningjs/sdk'

import { Touch } from '../utils'

import BrandButton from './BrandButton.js'

export default class BrandButtonGrid extends Lightning.Component {
  // Lifecycle
  _construct() {
    this._index = 0
    this._items = []
  }

  _init() {
    const touchHandler = new Touch()
    touchHandler.enable(this.stage)
  }

  // Template
  static _template() {
    return {
      flex: { direction: 'row', wrap: true },
    }
  }

  // Getters / Setters
  set items(items) {
    this._items = items
    this.children = items.map(item => {
      return {
        type: BrandButton,
        item,
      }
    })
  }

  get items() {
    return this.children
  }

  get currentItem() {
    return this.items[this._index]
  }

  // Util Methods
  findItem(direction) {
    let newIndex = this._index
    let matchFunc
    switch (direction) {
      case 'up':
        matchFunc = (item, currentItem, bestMatch) => {
          return (
            item.finalX == currentItem.finalX &&
            item.finalY < currentItem.finalY &&
            (!bestMatch || item.finalY > this.items[bestMatch].finalY)
          )
        }
        break
      case 'down':
        matchFunc = (item, currentItem, bestMatch) => {
          return (
            item.finalX == currentItem.finalX &&
            item.finalY > currentItem.finalY &&
            (!bestMatch || item.finalY < this.items[bestMatch].finalY)
          )
        }
        break
      case 'left':
        matchFunc = (item, currentItem, bestMatch) => {
          return (
            item.finalX < currentItem.finalX &&
            item.finalY == currentItem.finalY &&
            (!bestMatch || item.finalX > this.items[bestMatch].finalX)
          )
        }
        break
      case 'right':
        matchFunc = (item, currentItem, bestMatch) => {
          return (
            item.finalX > currentItem.finalX &&
            item.finalY == currentItem.finalY &&
            (!bestMatch || item.finalX < this.items[bestMatch].finalX)
          )
        }
        break
    }
    let bestMatch
    this.items.forEach((item, index) => {
      if (matchFunc(item, this.currentItem, bestMatch)) {
        bestMatch = index
      }
      if (bestMatch !== undefined) {
        newIndex = bestMatch
      }
    })
    return newIndex
  }

  // Event Handlers
  _getFocused() {
    return this.children[this._index]
  }

  _handleUp() {
    this._index = this.findItem('up')
  }

  _handleDown() {
    this._index = this.findItem('down')
  }

  _handleLeft() {
    let newIndex = this.findItem('left')
    if (newIndex == this._index && this._index > 0) {
      newIndex -= 1
    }
    this._index = newIndex
  }

  _handleRight() {
    let newIndex = this.findItem('right')
    if (newIndex == this._index && this._index < this.items.length - 1) {
      newIndex += 1
    }
    this._index = newIndex
  }

  _handleEnter() {
    let item = this._items[this._index]
    let itemData = item.data
    Router.navigate(item.href, { item: itemData })
  }

  _handleTouch(element) {
    for (const [itemIndex, item] of this.children.entries()) {
      if (element.__id === item.__id) {
        this._index = itemIndex
        Router.navigate(item.item.href, { item: item.item.data })
      }
    }
  }
}
